import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { Carousel } from '../../../component/carousel';
import { pxToRem } from '../../../utils/pxToRem';
import { AgentCard } from '../../agents/allAgents/component/agentCard';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const ContainerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 40px;
  column-gap: 40px;
  @media (max-width: 600px) {
    flex-direction: column;
    column-gap: 0px;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 8px 8px 35px 8px;
  margin: 0px 10px;
  margin-bottom: 48px;
  flex: 1;

  @media (max-width: 500px) {
    margin: 0;
    margin-bottom: 48px;
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddPromotionBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;
export const PromotionImage = styled(Carousel)`
  border-radius: 16px;
  width: 100%;
  height: 400px;
  max-width: 875px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
export const Div = styled.div`
  margin: 37px 32px 0px 32px;
`;
export const PromotionName = styled.p`
  font-size: ${pxToRem(21)};
  line-height: ${pxToRem(29)};
  letter-spacing: ${pxToRem(0.15)};
  font-style: normal;
  font-weight: 500;
  color: #32324b;
  text-align: left;
  text-transform: capitalize;
`;
export const DurationWrap = styled.div`
  display: flex;
  align-items: center;
`;
export const DurationText = styled.p`
  font-weight: 500;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};
  letter-spacing: ${pxToRem(0.15)};
  color: #32324b;
`;
export const Date = styled(DurationText)`
  color: #a1a1a1;
  margin: 0px 4px;
`;
export const ToText = styled(DurationText)``;
export const Flex = styled.div`
  display: flex;
  align-items: center;
`;
export const Location = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(20)};
  color: #a1a1a1;
  margin: 0px 4px;
`;
export const Booking = styled(Location)``;
export const DescriptionTitle = styled(PromotionName)`
  font-size: ${pxToRem(16)};
  margin: 37px 0px 16px 0px;
`;
export const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(23)};
  color: #32324b;
`;
export const RightHandSideConainer = styled.div``;
export const ViewsText = styled(PromotionName)`
  text-align: center;
`;
export const NumberOfViews = styled(ViewsText)`
  color: #a1a1a1;
`;
export const BookingText = styled(ViewsText)``;
export const NumberOfBookings = styled(NumberOfViews)``;
export const ViewContainer = styled.div`
  width: 176px;
  margin: 64px auto;
  padding: 24px 0px;
  margin-top: 64px;
  background: #ffffff;
  border: 0.3px solid #fda800;
  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08);
  border-radius: 8px;
  @media (max-width: 600px) {
  }
`;
export const CustomAgentCard = styled(AgentCard)`
  width: unset;
  flex: 0.4;
  margin: 0;
  margin-bottom: 20px;
  @media (max-width: 1000px) {
    width: unset;
    margin: 0px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: auto;
    margin: 0;
    margin-bottom: 48px;
  }
`;
